(function (root, factory) {
    const pluginName = 'PearsonVideo';

    // eslint-disable-next-line no-undef
    if (typeof define === 'function' && define.amd) {
        // eslint-disable-next-line no-undef
        define([], factory(pluginName));
    } else if (typeof exports === 'object') {
        module.exports = factory(pluginName);
    } else {
        root[pluginName] = factory(pluginName);
    }
// eslint-disable-next-line no-unused-vars
}(this, (pluginName) => {
    const defaults = {
        mainVideoClass: '.prototype-video__mainVideo',
        playlistItemClass: 'prototype-video__playlistItem',
        openModalClass: 'prototype-video__img',
        closeModalClass: 'prototype-video__modalClose',
        focusEndClass: '.focusEndBtn',
        focusStartClass: '.prototype-video__modalClose',
    };
    /**
     * Merge defaults with user options
     * @param {Object} defaults Default settings
     * @param {Object} options User options
     */
    const extend = function (target, options) {
        let prop;
        const extended = {};
        // eslint-disable-next-line no-restricted-syntax
        for (prop in defaults) {
            if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
                extended[prop] = defaults[prop];
            }
        }
        // eslint-disable-next-line no-restricted-syntax
        for (prop in options) {
            if (Object.prototype.hasOwnProperty.call(options, prop)) {
                extended[prop] = options[prop];
            }
        }
        return extended;
    };

    /**
     * DOM Elements validation
     * @private
     * @param {Object} options User options
     * @returns {Boolean} true if all required DOM elements are present
     */
    const checkForRequredDOMElements = function (options) {
        const modalBtn = document.getElementsByClassName(options.openModalClass);
        // Check if open modal image/button is present
        if (modalBtn.length === 0) {
            return false;
        }
        return true;
    };

    /**
     * Change state of modal
     * @param {DOMNode} video from playlist
     * @function
     */
    const changeMainVideo = function (video) {
        // Get the image/button that opens the modal
        const btn = document.getElementsByClassName(defaults.openModalClass);

        // Choose video from playlist
        [].forEach.call(btn, (elem) => {
            const mainVideo = elem.nextElementSibling.querySelector(defaults.mainVideoClass);
            mainVideo.setAttribute('src', video.getAttribute('src'));
        });
    };

    /**
     * Activates the action button with the enter key or the space key, and change the main video
     * @param {KeyboardEvent} event
     */
    function actionButtonKeyupHandlerPlaylist(event) {
        if (event.keyCode === 32) {
            changeMainVideo(this);
        } else if (event.keyCode === 13) {
            changeMainVideo(this);
        }
    }

    /**
     * Change state of playlist
     * @param {Object} options User options
     * @function
     */
    const playlistStateChange = function (options) {
        const videoList = document.getElementsByClassName(options.playlistItemClass);
        [].forEach.call(videoList, (list) => {
            // Choose video from playlist on click
            list.addEventListener('click', function () {
                changeMainVideo(this);
            });
            // Choose video from playlist with the enter key or the space key
            list.addEventListener('keyup', actionButtonKeyupHandlerPlaylist);
        });
    };

    /**
     * Get focusable elements
     * @private
     * @param {DOMNode} focusEl - modal
     * @returns {Object[]} array of focusable elements inside modal
     */
    const getFocusableEls = function (focusEl) {
        // eslint-disable-next-line max-len
        return focusEl.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), iframe, .prototype-video__youtube');
    };

    /**
     * Sets focus inside the modal
     * @private
     * @param {HTMLElement} focusEl - modal
     * @param {Object} options
     */
    const setFocus = function (focusEl, options) {
        const KEY_TAB = 'Tab';
        const closeButton = focusEl.querySelector(`.${options.closeModalClass}`);
        const focusableEls = getFocusableEls(focusEl);
        const lastFocusableEl = focusableEls[focusableEls.length - 1];
        const firstFocusableEl = focusableEls[0];

        // sets focus on the first focusable el or close button if modal is open
        if (focusEl.style.display === 'block') {
            if (closeButton) {
                closeButton.focus();
            } else {
                firstFocusableEl.focus();
            }
        }

        focusEl.addEventListener('keydown', (e) => {
            const isTabPressed = (e.key === KEY_TAB || e.code === KEY_TAB);

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    e.preventDefault();
                    lastFocusableEl.focus();
                }
            } else if (document.activeElement === lastFocusableEl) {
                e.preventDefault();
                firstFocusableEl.focus();
            }
        });
    };

    /**
     * Stop the video when modal close
     *
     * @param {DOMNode} player main video
     */
    const stopVideo = function (player) {
        const vidSrc = player.getAttribute('src')
            .replace('autoplay=1', 'autoplay=0');
        player.setAttribute('src', vidSrc);
    };

    /**
     * Activates the action button with the enter key or the space key, and open the modal
     *
     * @param {KeyboardEvent} event
     */
    function actionButtonKeyupHandler(event) {
        if (event.key === 'Space') {
            this.nextElementSibling.style.display = 'block';
            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('tabindex', '-1');
            const focusableEls = getFocusableEls(this.nextElementSibling);
            focusableEls[0].focus();
        } else if (event.key === 'Enter') {
            this.nextElementSibling.style.display = 'block';
            this.setAttribute('aria-hidden', 'true');
            this.setAttribute('tabindex', '-1');
            const focusableEls = getFocusableEls(this.nextElementSibling);
            focusableEls[0].focus();
        }
    }

    /**
     * Change state of modal
     * @param {Object} options User options
     * @function
     */
    const modalStateChange = function (options) {
        // Get the image/button that opens the modal
        const btn = document.querySelectorAll(`.${options.openModalClass}`);
        const modalContent = document.querySelector('.prototype-video__modal');

        // When the user clicks on the image/button, open the modal
        btn.forEach((elem) => {
            elem.addEventListener('click', () => {
                elem.nextElementSibling.style.display = 'block';
                elem.setAttribute('aria-hidden', 'true');
                elem.setAttribute('tabindex', '-1');

                // Set focus inside the modal
                setFocus(modalContent, options);

                stopVideo(document.getElementsByClassName('prototype-video__mainVideo')[0]);

                if (elem.nextElementSibling.style.display === 'none') {
                    elem.addEventListener('keyup', actionButtonKeyupHandler);
                }

                // When the user clicks anywhere outside of the modal, close it
                window.addEventListener('click', (event) => {
                    if (event.target === elem.nextElementSibling) {
                        elem.nextElementSibling.style.display = 'none';
                        elem.setAttribute('aria-hidden', 'false');
                        elem.removeAttribute('tabindex');
                        elem.focus();
                        stopVideo(document.getElementById('modalVideo'));
                    }
                });

                // When the user press esc key, close the modal
                window.addEventListener('keydown', (event) => {
                    if (event.key === 'Escape' || event.key === 'Esc') {
                        elem.nextElementSibling.style.display = 'none';
                        elem.setAttribute('aria-hidden', 'false');
                        elem.removeAttribute('tabindex');
                        elem.focus();
                        stopVideo(document.getElementById('modalVideo'));
                    }
                });

                // When user clicks on 'x' button, close the modal
                const close = elem.nextElementSibling.getElementsByClassName(options.closeModalClass);
                [].forEach.call(close, (element) => {
                    element.addEventListener('click', () => {
                        element.parentElement.parentElement.style.display = 'none';
                        element.parentElement.parentElement.previousElementSibling.setAttribute('aria-hidden', 'false');
                        element.parentElement.parentElement.previousElementSibling.removeAttribute('tabindex');
                        element.parentElement.parentElement.previousElementSibling.focus();
                        stopVideo(document.getElementById('modalVideo'));
                    });
                });
            });
        });
    };

    /**
     * Plugin Object
     * @param {Object} options User options
     * @constructor
     */
    function Plugin(options) {
        this.options = extend(defaults, options);

        this.init();
    }

    /**
     * Plugin prototype
     * @public
     * @constructor
     */
    Plugin.prototype = {
        init() {
            if (checkForRequredDOMElements) {
                // modal state change
                modalStateChange(this.options);
                // playlist state change
                playlistStateChange(this.options);
            }
        },
    };
    return Plugin;
}));
